// Purpose: share download placeholder (access code entry). Legacy
// recipient page at /s/:token/legacy — superseded by RecipientLanding
// but kept for backward-compat routing.

import { useParams } from 'react-router-dom';
import { Card } from '../components/ui/index.ts';

export function Share() {
  const { token } = useParams<{ token: string }>();
  return (
    <div className="flex flex-col gap-8">
      <header className="flex flex-col gap-3">
        <span className="text-label uppercase text-accent-primary">Secure File Retrieval</span>
        <h1 className="font-display text-display-l text-fg-primary [font-feature-settings:var(--font-feature-display)]">
          Retrieve file
        </h1>
        <p className="text-body-l text-fg-secondary">
          Enter the access code shared with you to download the file.
        </p>
      </header>
      <Card padding="comfortable">
        <div className="flex flex-col gap-3">
          <p className="text-body-m text-fg-secondary">
            Share token: <code className="font-mono text-body-s text-fg-primary">{token}</code>
          </p>
          <p className="text-body-s text-fg-muted">Code entry and download ship in Phase 4.</p>
        </div>
      </Card>
    </div>
  );
}
